import { APISettings } from '../config.js';
import loginMethods from '../resources/loginMethods.js'
import { useUserStore } from '@/stores/userStore.js';
export default {
    name: "orderMethods",

    async getOrders(id = null) {
        //console.log("Starting request");
        let src = "/backend/orders";
        if (id) {
            src = "/backend/orders/" + id;
        }
        try {
            const response = await fetch(src, {
                method: 'GET',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                }
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async postOrder(obj) {
        try {
            const response = await fetch("/backend/orders", {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async deleteOrder(id) {
        try {
            const response = await fetch("/backend/orders/" + id, {
                method: 'DELETE',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(id)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },


    async generatePDF(obj) {
        if (!obj.MQInput || !obj.systemInput || !obj.baseInput || !obj.customerInput) {
            emit('alert', { message: "Seleziona un cliente!", color: "red" });
            return;
        }
        var user = useUserStore();
        let order = JSON.parse(JSON.stringify(obj.finalResult));

        order = order.filter((product) => product.variations.length > 0);

        console.log(order)
        // Funzione per caricare il logo come base64
        const loadLogo = () => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.src = 'img/background.jpg';
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0);
                    resolve(canvas.toDataURL('image/jpg'));
                };
                img.onerror = reject;
            });
        };

        // Ottieni il logo come base64
        const logoBase64 = await loadLogo();

        const docDefinition = {
            pageMargins: [40, 60, 40, 40],
            content: [
                //{ image: logoBase64, width: 150, height: 50, alignment: 'center', margin: [0, 0, 0, 10] },  // Aggiungi il logo
                { text: "Preventivo Cliente", style: "header", alignment: "center" },
                { text: `Cliente: ${obj.customerInput.name}`, style: "subheader" },
                { text: `Data: ${new Date(obj.date).toLocaleDateString()}`, style: "subheader" },
                { text: "Dettagli Preventivo", style: "sectionHeader" },
                {
                    table: {
                        widths: ["33%", "33%", "33%"],
                        headerRows: 1,
                        body: [
                            [
                                { text: "Sistema", style: "tableHeader" },
                                { text: "Superficie", style: "tableHeader" },
                                { text: "MQ", style: "tableHeader" }
                            ],
                            [{text:obj.systemInput.system_name,alignment:"center"},{text:obj.baseInput.base_name,alignment:"center"} ,{text:obj.MQInput,alignment:"center"}]
                        ]
                    },
                    layout: "lightHorizontalLines",
                    margin: [40, 5, 0, 5]
                },
                { text: "Prodotti", style: "sectionHeader" }
            ],
            styles: {
                header: { fontSize: 22, bold: true, margin: [0, 50, 0, 10] },
                subheader: { fontSize: 14, margin: [40, 5, 0, 5] },
                sectionHeader: { fontSize: 16, bold: true, margin: [40, 15, 0, 10] },
                tableHeader: { bold: true, fillColor: "#eeeeee", alignment: "center" },
                productHeader: { fontSize: 12, bold: true, margin: [0, 10, 0, 5] },
                tableCell: { margin: [5, 5, 5, 5], alignment: "center" },
                totalText: { fontSize: 14, bold: true, alignment: "right", margin: [0, 10, 0, 0] }
            },
            images: {
                backgroundWatermark: logoBase64
            },
            background: function (currentPage, pageSize) {
                return {
                    image: 'backgroundWatermark',
                    width: pageSize.width,  // Imposta la larghezza uguale alla larghezza della pagina
                    height: pageSize.height, // Imposta l'altezza uguale all'altezza della pagina
                    absolutePosition: { x: 0, y: 0 } // Posiziona l'immagine nell'angolo in alto a sinistra
                };
            },
        };
        order.forEach((product) => {
            let productHeader = {
                text: `${product.product_name} - Prezzo: ${obj.currency}${product.total.toFixed(2)} ${product.discount ? `- Sconto: ${product.discount}%` : ""}`,
                style: "productHeader",
                margin: [40, 5, 0, 5]
            };

            let productTable = {
                table: {
                    widths: ["50%", "50%"],
                    body: [
                        [
                            { text: "Confezione", style: "tableHeader" },
                            { text: "Quantità", style: "tableHeader" }
                        ]
                    ]
                },
                layout: "lightHorizontalLines",
                margin: [40, 5, 0, 5]
            };

            product.variations.forEach((variation) => {
                productTable.table.body.push([
                    { text: variation.packaging_label, style: "tableCell" },
                    { text: variation.quantity, style: "tableCell" }
                ]);
            });

            docDefinition.content.push({
                unbreakable: true,
                stack: [
                    productHeader,
                    productTable
                ]
            });
        });

        // Aggiungi il costo della manodopera separatamente (già calcolato)
        if (obj.manodopera > 0) {
            docDefinition.content.push({ text: `Manodopera: ${obj.currency}${obj.manodopera}`, style: "totalText" });
        }

        // Aggiungi il totale finale (già calcolato)
        if (obj.discount != 0) {
            docDefinition.content.push({ text: `Sconto sul totale applicato: ${obj.discount}%`, style: "totalText" });
        }
        docDefinition.content.push({ text: `Totale: ${obj.currency}${obj.total}`, style: "header", alignment: "right" });
        docDefinition.content.push({ text: `(Iva esclusa)`, alignment: "right" });

        if (obj.orderNotes && obj.orderNotes.length > 0) {
            docDefinition.content.push({ text: `Note:`, style: "sectionHeader", alignment: "left" });
            docDefinition.content.push({ text: obj.orderNotes, margin: [40, 0, 0, 10], alignment: "left" });
        }

        docDefinition.footer = function (currentPage, pageCount) {
            return {
                margin: [40, 0, 40, 0], // Margini: [sinistra, sopra, destra, sotto]
                columns: [
                    {
                        // Colonna Sinistra (vuota o per altri dati)
                        text: '',
                    },
                    {
                        // Colonna Destra
                        alignment: 'right',
                        stack: [
                            // Mostra il nome utente solo se è l'ultima pagina
                            (currentPage === pageCount) ? { text: user.loggedUsername, italics: true, fontSize: 14 } : '',
                            // Numero di pagina (mostrato su tutte le pagine)
                            { text: 'Pagina ' + currentPage + ' di ' + pageCount, fontSize: 10 }
                        ]
                    }
                ]
            };
        };


        if (user.isApple) {
            pdfMake.createPdf(docDefinition).download();
        }
        else {
            pdfMake.createPdf(docDefinition).open();
        }
    }


}